import { ToggleGroupButton as Button } from './ToggleGroupButton'
import { ToggleGroupItem as Item } from './ToggleGroupItem'
import { ToggleGroupRoot as Root } from './ToggleGroupRoot'

export const ToggleGroup = { Item, Button, Root }
